define('views/blocks/ProductSidedishGroupedListView',['underscore', 'jquery', 'backbone', 'app','views/blocks/ProductSidedishView'],
function(_,jQuery,BackBone,app,ProductSidedishView){
    return ProductSidedishView.extend({
        events: {
        'change .sidedish-list-grouped__checkable':'checkInputs',
        'click .sidedish-list-grouped__input--multiple .btn-quantity, .sidedish-list-grouped__number':'uptadeMultipleInputs'
        },
        start:function() {
            this.updateInputs();
        },
        updateInputs:function(){
            var view = this;
            view.$('.sidedish-list-grouped__input').each(function(){
                var $el = $(this),
                    input = $(this).find('input');
                if($el.is(':not(.sidedish-list-grouped__input--multiple)')){
                    // simple selection
                    $el.toggleClass('active',input.is(':checked'));
                }else{
                    // multiple selection
                    var bullet = $el.find('.bullet'),
                        active = input.val() > 0,
                        bulletText = active ? input.val() : '';
                    $el.toggleClass('active',active);
                    bullet.text(bulletText);
                    input.val(input.val());
                }
            });
        },
        triggerChange:function(){
            var view = this;
            view.updateInputs();
            view.warn(true);
            view.trigger('change');
        },
        checkInputs:function(e) {
            // radio & checkbox
            var view = this,
                target = e.target,
                id_cross_selling = target.dataset.id_cross_selling,
                id_product = target.value,
                checked = target.checked,
                add = checked,
                sidedish = view.sidedish.getChild(id_cross_selling),
                qty = sidedish.getSelectionQuantity(),
                max = sidedish.getMaximum(),
                selection = sidedish.getSelection();
            //
            if(qty>=max && add){
                // si on essaie d'ajouter et qu'on est au maximum
                var shiftedSelection = selection.shift();
                view.$('input#'+sidedish.id+'_'+shiftedSelection.id).attr('checked',false);
            }
            sidedish.changeSelection(add,id_product);
            view.triggerChange();
        },
        uptadeMultipleInputs:function(e) {
            var view = this,
                button = $(e.target),
                field = button.closest('.sidedish-list-grouped__input--multiple'),
                input = field.find('input[type="number"]'),
                id_product = input.attr('name'),
                id_cross_selling = input.data().id_cross_selling+'',
                add = !button.is('.less'),
                sidedish = view.sidedish.getChild(id_cross_selling),
                qty = sidedish.getSelectionQuantity(),
                max = sidedish.getMaximum();
            ;
            if(qty>=max && add){
                // si on essaie d'ajouter et qu'on est au maximum
                return;
            }
            sidedish.changeSelection(add,id_product);
            input.val(sidedish.getSelectionQuantity(id_product));
            view.triggerChange();
        },
        warn:function(ignoreScroll){
          var view = this, scrollTo = ignoreScroll;
          view.sidedish.eachChildren(function(sidedish){
              var validate = sidedish.validateSelection(),
                  $el = view.$('.sidedish-group-'+sidedish.id);
              $el.toggleClass('sidedish-list-grouped__list--has-error',!validate);
              $el.find('.sidedish-list-grouped__list-countdown').text(sidedish.getErrorDescription());
              if(!validate && !scrollTo){
                  scrollTo = $el.position().top;
                  app.scrollTop(scrollTo,300);
              }

          });
        },
    })
})
;
